import { createContext, useContext, useEffect, useState } from "react";
import { discounted } from "@/lib/layout";

const CartCtx = createContext(null);

export function CartProvider({ children }) {
  const [items, setItems] = useState(() => {
    try {
      return JSON.parse(localStorage.getItem("hs_cart") || "[]");
    } catch {
      return [];
    }
  });

  useEffect(() => {
    localStorage.setItem("hs_cart", JSON.stringify(items));
  }, [items]);

  const add = (item) => {
    const key = `${Date.now()}-${Math.random().toString(36).slice(2, 7)}`;
    setItems((s) => [...s, { ...item, key }]);
    return key;
  };
  const update = (key, patch) => setItems((s) => s.map((i) => (i.key === key ? { ...i, ...patch } : i)));
  const remove = (key) => setItems((s) => s.filter((i) => i.key !== key));
  const setQty = (key, q) =>
    setItems((s) => s.map((i) => {
      if (i.key !== key) return i;
      const quantity = Math.max(1, Math.min(100, q));
      return { ...i, quantity, unit_price: i.base_price != null ? discounted(i.base_price, i.tiers, quantity) : i.unit_price };
    }));
  const clear = () => setItems([]);
  const setPads = (key, n) => setItems((s) => s.map((i) => (i.key === key ? { ...i, pads: Math.max(0, Math.min(100, n)) } : i)));
  const lineTotal = (i) => i.unit_price * i.quantity + (i.pad_price || 0) * (i.pads || 0);
  const subtotal = items.reduce((a, i) => a + lineTotal(i), 0);
  const count = items.reduce((a, i) => a + i.quantity, 0);

  return <CartCtx.Provider value={{ items, add, update, remove, setPads, lineTotal, setQty, clear, subtotal, count }}>{children}</CartCtx.Provider>;
}

export const useCart = () => useContext(CartCtx);
